module.exports = __webpack_public_path__ + "img/bingo_ball-32.641e7dcb.png";